module.exports = __webpack_public_path__ + "img/ring_g_e_null_0@3x.f24c48e3.png";